<template>
    <svg height="19.232" viewBox="0 0 19.232 19.232" width="19.232" xmlns="http://www.w3.org/2000/svg">
        <g id="Group_2632" data-name="Group 2632" transform="translate(-1773.651 -161.651)">
            <path
                id="Intersection_2"
                d="M0,8.765a8.766,8.766,0,1,1,8.766,8.766A8.766,8.766,0,0,1,0,8.765Z"
                data-name="Intersection 2"
                fill="none"
                stroke="#1bc5bd"
                stroke-width="1.7"
                transform="translate(1774.502 162.501)"
            />
            <path
                id="Path_2213"
                d="M23.746,9.6l-3.071,7.065-2.54-2.522"
                data-name="Path 2213"
                fill="none"
                stroke="#1bc5bd"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.7"
                transform="translate(1762.254 158.363)"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Online",
};
</script>
